import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { usePreloadImages } from '../../hooks/usePreloadImages';
import { LayoutDataType } from '../../types';

import { Option, OptionList } from './components/Option';
import { GENDER_OPTIONS } from './constants';
import {
  OptionsContainerStyles,
  TitleStyles,
  SubtitleStyles,
} from './Gender.styles';

export const ScreenGender: React.FC = () => {
  usePreloadImages();

  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Gender',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();
  const gender = form.watch('gender');

  const handleSelect = (option: OnbOptionType<LayoutDataType['gender']>) => {
    form.setValue('gender', option.id);
    userService.createOrUpdate({
      onboarding_data: {
        gender: option.id,
      },
    });
    nextStepTimeout(wizard.nextStep);
  };

  return (
    <OnboardingPage>
      <OnboardingNavigation />
      <TitleStyles>Choose the Gender</TitleStyles>
      <SubtitleStyles>Who are you spending this night with?</SubtitleStyles>
      <IonContent scrollY={false}>
        <OptionsContainerStyles className="options-container">
          <OptionList>
            {GENDER_OPTIONS.map((option) => (
              <Option
                title={option.title}
                isSelected={gender === option.id}
                onClick={() => handleSelect(option)}
                Icon={option.Icon}
                iconPosition={option.iconPosition}
                key={option.id}
              />
            ))}
          </OptionList>
        </OptionsContainerStyles>
      </IonContent>
    </OnboardingPage>
  );
};
